import React, { useState } from 'react'
import { Query } from 'react-apollo'
import moment from 'moment'
import { useQuery, useMutation } from '@apollo/react-hooks'
import {
  Col, Input, Modal, Select, message,
} from 'antd'
import _ from 'lodash'
import InfiniteScroll from 'react-infinite-scroller'
import {
  Div, H3, Button, Loading, DynamicButtonLink, P, H4, H5,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { TRUCK_TIRE_LIST } from '../../../constants/graph/query'
import { SWAP_TRUCK_TIRE } from '../../../constants/graph/mutation'
import '../list/style-css.css'
import { Wrapper } from '../../../components/truck-components'
import { TRUCK_INFO } from '../../../constants/graphql/query'
import history from '../../../history'
import { getAccessToken, getURL } from '../../../utils/local-data-service'

const { color } = theme

const TireSwapModal = ({
  data, swapModal, setSwapModal, swapDoAction, swapLoading, refetch,
}) => {
  const [wheelId, setWheelId] = useState()
  const [wheelNo, setWheelNo] = useState()
  return (
    <Modal
      title="กรุณาเลือกล้อที่ต้องการสลับ"
      visible={swapModal}
      destroyOnClose={true}
      onCancel={() => {
        setSwapModal(false)
        setWheelId()
        setWheelNo()
      }}
      onOk={() => {
        swapDoAction({
          variables: {
            id: wheelId,
            wheelNo,
          },
        }).then((resp) => {
          const KEY = 'SwitchTruckTire'
          if (resp.data[KEY].success) {
            message.success(resp.data[KEY].message)
            refetch()
          } else message.error(resp.data[KEY].message)
        })
        setSwapModal(false)
        setWheelId()
        setWheelNo()
      }}
      okButtonProps={{
        loading: swapLoading,
        disabled: _.isUndefined(wheelId) && _.isUndefined(wheelNo),
      }}
      cancelButtonProps={{
        disabled: swapLoading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <P margin='8px 16px 16px 0'>ล้อที่</P>
        <Select
          style={{ width: '130px', margin: '8px 16px 16px 0' }}
          onSelect={(e) => {
            setWheelId(e)
          }}
        >
          {
            data.map(v => <Select.Option key={v.id} value={v.id}>{v.wheelNo}</Select.Option>)
          }
        </Select>
        <P margin='8px 16px 16px 0'>สลับกับ ล้อที่</P>
        <Input
          style={{ width: '130px', margin: '-7px 0 0 0' }}
          value={wheelNo}
          onChange={(e) => {
            setWheelNo(e.target.value)
          }}
        />
      </Div>
    </Modal>
  )
}

const printTireList = (id, setIsLoading) => {
  setIsLoading(true)
  window.open(
    `${getURL().FILE_SERVER}/render/pdf/truckTires/${id}?t=${getAccessToken()}`,
    '_blank',
    'toolbar=false,scrollbars=yes,resizable=false',
  )
  setIsLoading(false)
}

export default ({ props }) => {
  const {
    data, loading, error, refetch,
  } = useQuery(TRUCK_TIRE_LIST, { variables: { truckId: parseInt(props.match.params.id, 10) } })
  const [swapDoAction, { loading: swapLoading }] = useMutation(SWAP_TRUCK_TIRE)
  const [swapModal, setSwapModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  if (loading && _.isEmpty(data)) return <Loading center='true' />
  if (error) return <p>เกิดข้อผิดพลาด</p>
  if (data.TruckTireList.lists.length === 0) return <H3 bold color={color.primaryColor} margin='32px 0'>ไม่มีข้อมูลล้อของรถบรรทุกนี้</H3>
  return (
    <Div display='flex' flexDirection='column'>
      <Wrapper overflow padding='0 0 40px 0' flex>
        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
          <H3 bold color={color.primaryColor} margin='32px 0'>ข้อมูลล้อรถบรรทุก</H3>
          <Div display='flex' flexDirection='row' justifyContent='flex-end'>
            <Button disabled={isLoading} margin='0 16px 0 16px' text='พิมพ์ข้อมูลล้อ' loading={isLoading} onClick={() => printTireList(parseInt(props.match.params.id, 10), setIsLoading)} />
            <Button disabled={false} margin='0 16px 0 16px' text='ดูประวัติการเปลี่ยนยาง' icon='fas fa-history' onClick={() => history.push(`/truck/tire-history/${props.match.params.id}`)} />
            <Button disabled={false} margin='0 16px 0 16px' text='สลับยาง' color={color.error} onClick={() => setSwapModal(true)} />
          </Div>
        </Div>
        <Div display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center' padding='0'>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>ทะเบียนหัว</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TruckTireList.lists[0].Truck.plateNumber}</P>
            </Div>
          </Col>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>ชนิดรถ</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TruckTireList.lists[0].Truck.type ? data.TruckTireList.lists[0].Truck.type.nameTh : 'ไม่มีข้อมูล'}</P>
            </Div>
          </Col>
          <Col md={{ span: 4 }}>
            <Div display='flex' justifyContent='center' margin='8px 0 24px'>
              <P bold>เลขคัสซี</P>
            </Div>
            <Div display='flex' justifyContent='center' margin='8px 0 16px'>
              <P>{data.TruckTireList.lists[0].Truck.chassisNumber ? data.TruckTireList.lists[0].Truck.chassisNumber : 'ไม่มีข้อมูล'}</P>
            </Div>
          </Col>
        </Div>
      </Wrapper>
      <Div>
        <Wrapper overflow padding='40px 0 40px 0' flex>
          <Div display='flex' flexDirection='row' margin='8px 0 24px'>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ล้อที่</P></Div></Col>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>เบอร์ยาง</P></Div></Col>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ชื่อยาง</P></Div></Col>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ประเภทยาง</P></Div></Col>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เริ่มใช้</P></Div></Col>
            <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ไมล์เข้า</P></Div></Col>
          </Div>
          {
            _.map(data.TruckTireList.lists, v => <Div display='flex' flexDirection='row' margin='8px 0 16px'>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.wheelNo}</P></Div></Col>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Serial.serialNumber}</P></Div></Col>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Serial.inventoryOption.variantName}</P></Div></Col>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Serial.Tire && v.Serial.Tire.TireType ? v.Serial.Tire.TireType.name : 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Detail && v.Detail.inDate ? moment(v.Detail.inDate).format('DD-MM-YYYY') : 'ไม่มีข้อมูล'}</P></Div></Col>
              <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.Detail && v.Detail.startMileAge ? v.Detail.startMileAge : 'ไม่มีข้อมูล'}</P></Div></Col>
            </Div>)
          }
        </Wrapper>
      </Div>
      <TireSwapModal data={data.TruckTireList.lists} swapModal={swapModal} setSwapModal={setSwapModal} swapDoAction={swapDoAction} swapLoading={swapLoading} refetch={refetch} />
    </Div>
  )
}
